export default {
    IS_THERE_ENTITY: 'Do you have {{role}} in your startup?',
    IS_ENTITY:'Your {{role}}'
}